import React, { Fragment, useState, useEffect } from 'react';
import { Notification, Card, Table, Button, Title, Modal, Box, Tag, Progress, Column } from "rbx";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';
import PdvService from '../../../services/pdv';
import { types, vehicleTypes } from '../../../commons/constants';
import PaginationCustom from '../../components/PaginationCustom';
import Timer from '../../components/Timer';
import { placaMask, monetaryMask } from '../../../commons/masks';
import { getDiffTime } from '../../../commons/utils';

const PdvVehiclesParkedList = (props) => {
  const { goToMenu } = props;
  const [parkings, setParkings] = useState([]);
  const [pageOfItems, setPageOfItems] = useState([]);
  const [activeProgress, setActiveProgress] = useState(true);
  const [activeModal, setActiveModal] = useState(false);
  const [selectedParking, setSelectedParking] = useState(null);
  const [status, setStatus] = useState('');

  useEffect(() =>{
    fetchVehiclesParked();
  },[])

  const fetchVehiclesParked = async () => {
    const pdv = JSON.parse(sessionStorage.getItem('pdv'));
    try {
      const response = await PdvService.vehiclesParked(pdv.cpf_cnpj, true);
      setParkings(response.data.history);
    } catch(e) {
      if (e.response)
        setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
      else
        setStatus(['danger', `${e.message}`]);
    }
    setActiveProgress(false);
  }

  const openModal = (index) => {
    setActiveModal(true);
    setSelectedParking(index);
  }

  const close = () => setActiveModal(false);

  const onChangePage = (ppageOfItems) => {
    setPageOfItems(ppageOfItems);
  }

  const headerVehiclesParked = () => (
    <Table.Row>
      <Table.Heading>Inicio</Table.Heading>
      <Table.Heading>Fim</Table.Heading>
      <Table.Heading>Placa</Table.Heading>
      <Table.Heading></Table.Heading>
    </Table.Row>
  )

  const renderVehiclesParked = () => {
    if (pageOfItems.length === 0)
      return (
        <Table.Row key={0}>
          <Table.Cell colspan="9">
            { (activeProgress) ? <Progress size='small' color='custom-purple' /> : 'Não há veículos estacionados para este PDV.' }
          </Table.Cell>
        </Table.Row>
      )
    else
      return (
        pageOfItems.map((parking, index) => (
          <Table.Row key={parking._id}>
            <Table.Cell>{moment(parking.date_started).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
            <Table.Cell>
              {
                (parking.date_ended) ? 
                  moment(parking.date_ended).format('DD/MM/YYYY HH:mm:ss') : 
                    <>
                      <Tag color="custom-purple">
                        <Timer startDate={parking.date_started} paidMinutes={parking.time_paid} reverse={false} />
                      </Tag>
                      <Tag className="ml-2" color="custom-purple">
                        <Timer startDate={parking.date_started} paidMinutes={parking.time_paid} reverse={true} />
                      </Tag>
                    </>
              }
            </Table.Cell>
            <Table.Cell>{placaMask(parking.licensePlate)}</Table.Cell>
            <Table.Cell>
              <Button key={parking._id} size="small" color="custom-purple" outlined onClick={() => openModal(index)} title="Detalhe">
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </Table.Cell>
          </Table.Row>
        ))
      )
  }

  const renderModal = () => {
    if (selectedParking !== null) {
      const parking = pageOfItems[selectedParking];
      const styleHr = {'background-color': 'transparent', 'border-color': 'rgb(221, 221, 221)', 'border-style': 'dashed', 'border-width': '1px 0px 0px', 'margin': '3px 0'};
      return (
        <Box>
          <Title size={5} className="mb-4">Detalhes do Estacionamento</Title>
          <hr style={ styleHr }/>
          <small><strong>Placa do veículo</strong></small><br />
          {placaMask(parking.licensePlate)}
          <hr style={ styleHr }/>
          <small><strong>Início</strong></small><br />
          {moment(parking.date_started).format('DD/MM/YYYY HH:mm:ss')}
          <hr style={ styleHr }/>
          <small><strong>Fim</strong></small><br />
          {
            (parking.date_ended) ? 
              moment(parking.date_ended).format('DD/MM/YYYY HH:mm:ss') : 
                <>
                  <Tag color="custom-purple">
                    <Timer startDate={parking.date_started} paidMinutes={parking.time_paid} reverse={false} />
                  </Tag>
                  <Tag className="ml-2" color="custom-purple">
                    <Timer startDate={parking.date_started} paidMinutes={parking.time_paid} reverse={true} />
                  </Tag>
                </>
          }
          <hr style={ styleHr }/>
          <small><strong>Coordenadas</strong></small><br />
          {parking.location.lat}; {parking.location.lng}
          <hr style={ styleHr }/>
          <small><strong>Foi renovado?</strong></small><br />
          {(parking.renewed) ? 'Sim' : 'Não'}
          <hr style={ styleHr }/>
          <small><strong>Local</strong></small><br />
          {parking.description}
          <hr style={ styleHr }/>
          <small><strong>Tipo do Veículo</strong></small><br />
          {vehicleTypes[parking.vehicleType]}
          <hr style={ styleHr }/>
          <small><strong>Regra de estacionamento do local</strong></small><br />
          {parking.rule.name}
          <hr style={ styleHr }/>
          <small><strong>Valor pago</strong></small><br />
          {monetaryMask(parking.money_spent/100)}
          <hr style={ styleHr }/>
          <small><strong>Código de Autenticação</strong></small><br />
          {parking.authenticationCode}
          <hr style={ styleHr }/>
          <small><strong>Tipo</strong></small><br />
          {types[parking.type]}
          <hr style={ styleHr }/>
          <small><strong>Tempo estacionado</strong></small><br />
          {getDiffTime(parking.date_started, parking.date_ended)}
          <hr style={ styleHr }/>
          <small><strong>Tempo pago</strong></small><br />
          {(parking.time_paid) ? parking.time_paid : '-'}
          <hr style={ styleHr }/>
          <small><strong>CADs utilizados</strong></small><br />
          {(parking.cads_spent) ? parking.cads_spent : '-'}
        </Box>
      )
    }
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Header.Title>Veículos Estacionados</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Table fullwidth>
            <Table.Head>
              { headerVehiclesParked() }
            </Table.Head>
            <Table.Body>
              { renderVehiclesParked() }
            </Table.Body>
          </Table>
          <Column.Group breakpoint="mobile">
            <Column className="has-text-left">
              <Link onClick={goToMenu} className="button is-primary">Voltar</Link>
            </Column>
            <Column className="has-text-right">
              <PaginationCustom items={parkings} onChangePage={onChangePage} />
            </Column>
          </Column.Group>
        </Card.Content>
      </Card>

      <Modal closeOnBlur={true} closeOnEsc={true} active={activeModal} onClose={close}>
        <Modal.Background onClick={close} />
        <Modal.Content>
          { renderModal() }
        </Modal.Content>
        <Modal.Close />
      </Modal>
    </Fragment>
  )

}

export default PdvVehiclesParkedList;

